// import { appInfo } from "@/common/data/appinfo";

export default [
  {
    path: "/NVj707f8e7470a577910277085477p3kZ",
    children: [

      {
        path: "08f338747021e0ea9f7decd2",
        name: "allConsents",
        meta: {
          title: "All Consents",
          authRequired: true,
          acc: ["noPam"],
        },
        component: () => import("@/views/consent/assigned.vue"),
      },
      {
        path: "09571e46972c840b4d45a0fb",
        name: "newConsent",
        meta: {
          title: "New Consent",
          authRequired: true,
          acc: ["noPam"],
        },
        component: () => import("@/views/consent/assign.vue"),
      },
    ],
  },
];
